<template>
  <div id='app'>
    <!--appHeader/-->
    <login v-if='!session.contents && showLoginPrompt'/>
    <router-view v-else></router-view>
  </div>
</template>

<script>
import session from "./lib/session";
import login from "@/components/login.vue";
import appHeader from "@/components/header.vue";
import Vue from "vue";
import VCalendar from "v-calendar";
import "v-calendar/lib/v-calendar.min.css";
import VeeValidate from "vee-validate";

Vue.use(VeeValidate);
Vue.use(VCalendar);

export default {
  name: "app",
  data() {
    return {
      session: session
    };
  },
  computed: {
    showLoginPrompt: function() {
      return this.$route.meta.showLoginPrompt;
    }
  },
  components: {
    login,
    appHeader
  }
};
</script>

<style lang='scss'>
body {
  background: $primary;
  color: $gray-1;
}
#app {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
}
</style>




// WEBPACK FOOTER //
// src/app.vue